<template>
  <div class="home">
    <v-container>
      <v-layout>
        <v-tabs v-model="tab">
          <v-tab to="/pin-types" class="text-none">
            <v-icon size="18" class="mr-1"> mdi-map-marker </v-icon>
            Pins</v-tab
          >
          <v-tab to="/regions" class="text-none">Regions</v-tab>
          <v-tab to="/entities" class="text-none">Entities</v-tab>
          <v-tab to="/entity-types" class="text-none">Entity Types</v-tab>
          <v-tab to="/tags" class="text-none">Tags</v-tab>
        </v-tabs>
      </v-layout>
      <v-divider />
      <router-view />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data() {
    return {
      tab: 0,
    };
  },
  created() {},
};
</script>
